/* Carriagetown theme JS: cart drawer (Shopify Ajax Cart API), shop filters, product gallery. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = document.getElementById('CartDrawer');
  var scrim = document.getElementById('CartScrim');
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function swap(sections) {
    var html = sections && sections['cart-drawer'];
    if (!html || !drawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var cur = drawer.querySelector('[data-cart-inner]');
    if (fresh && cur) { cur.replaceWith(fresh); setCount(fresh.dataset.count); }
  }

  function open() { if (!drawer) return; drawer.hidden = false; scrim.hidden = false; document.body.style.overflow = 'hidden'; drawer.querySelector('.ct-drawer__close').focus(); }
  function close() { if (!drawer) return; drawer.hidden = true; scrim.hidden = true; document.body.style.overflow = ''; }

  function req(url, data) {
    if (drawer) drawer.classList.add('is-busy');
    return fetch(root + url, {
      method: data ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: data ? JSON.stringify(data) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; });
    }).finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }
  function refresh() { return req('?sections=cart-drawer').then(swap); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart]');
    if (t && drawer) { e.preventDefault(); open(); refresh(); return; }
    if (e.target.closest('[data-close-cart]')) { close(); return; }
    var line = e.target.closest('[data-line]');
    if (line) {
      req('cart/change.js', { line: +line.dataset.line, quantity: Math.max(0, +line.dataset.qty), sections: 'cart-drawer' })
        .then(function (j) { swap(j.sections); }).catch(function (err) { alert(err.message); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) close(); });

  // Add to bag (product cards + product page forms)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.js-add-to-cart');
    if (!form || !drawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var fd = new FormData(form);
    var label = btn.innerHTML; btn.disabled = true;
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') props[m[1]] = v; });
    var item = { id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) };
    if (Object.keys(props).length) item.properties = props;
    req('cart/add.js', { items: [item], sections: 'cart-drawer' })
      .then(function (j) { btn.innerHTML = btn.dataset.added || 'ADDED'; swap(j.sections); open(); })
      .catch(function (err) { alert(err.message); })
      .finally(function () { btn.disabled = false; setTimeout(function () { btn.innerHTML = label; }, 1800); });
  });

  // Shop filter chips (client-side, by product type)
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    var grid = document.getElementById(group.dataset.filterGroup);
    group.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]'); if (!chip) return;
      group.querySelectorAll('[data-filter]').forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip); });
      var f = chip.dataset.filter, shown = 0;
      grid.querySelectorAll('[data-type]').forEach(function (card) {
        var on = f === 'all' || card.dataset.type === f; card.hidden = !on; if (on) shown++;
      });
      var empty = grid.parentNode.querySelector('[data-filter-empty]'); if (empty) empty.hidden = shown > 0;
    });
  });

  // Product gallery thumbs + qty stepper
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.js-gallery-main');
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-src]'); if (!b) return;
      main.src = b.dataset.src; main.srcset = '';
      g.querySelectorAll('[data-src]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
    });
  });
  document.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      input.value = Math.max(1, (+input.value || 1) + (+b.dataset.qtyStep));
    });
  });
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      var price = document.querySelector('[data-product-price]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      var btn = form.querySelector('[type=submit]');
      var avail = opt.dataset.available === 'true', bo = opt.dataset.backorder === 'true';
      btn.disabled = !avail;
      btn.innerHTML = !avail ? btn.dataset.soldout : (bo ? btn.dataset.labelBackorder : btn.dataset.label);
      var note = form.querySelector('[data-backorder-note]'); if (note) note.hidden = !bo;
      var prop = form.querySelector('[data-backorder-prop]'); if (prop) prop.disabled = !bo;
      var main = document.querySelector('.js-gallery-main');
      if (main && opt.dataset.image) { main.src = opt.dataset.image; main.srcset = ''; }
    });
  });
})();
